import type { CityConfig } from "../city-template/types";

export const sturgisConfig: CityConfig = {
  city: "Sturgis",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "sturgis",
  route: "/sturgis",
  title: "Emergency Passport Sturgis, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Sturgis, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Sturgis residents, motorcycle rally travelers, Meade County professionals, and Northern Black Hills communities.",
  h1: "Emergency & Expedited Passport Services in Sturgis, SD",
  heroSubtitle: "International motorcycle tour in Europe departing soon? Sturgis Rally vendor traveling to overseas motorcycle shows? Meade County family planning a European Alps adventure? We help Sturgis residents — from motorcycle industry professionals and rally vendors to Fort Meade personnel to Northern Hills families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Iconic%20view%20of%20downtown%20Sturgis%20South%20Dakota%20with%20historic%20Main%20Street%20lined%20with%20motorcycles%20and%20classic%20brick%20storefronts%20during%20the%20golden%20hour%2C%20the%20famous%20Sturgis%20Motorcycle%20Rally%20sign%20and%20American%20flags%2C%20Black%20Hills%20foothills%20rising%20in%20the%20background%20under%20a%20dramatic%20sunset%20sky%20with%20warm%20amber%20and%20orange%20tones%2C%20vintage%20neon%20signs%20and%20motorcycle%20culture%20atmosphere%20in%20a%20historic%20western%20town&width=1800&height=700&seq=sturgis-hero-2026&orientation=landscape",
  heroImageAlt: "Historic Main Street Sturgis South Dakota with motorcycles and Black Hills backdrop",
  geoPosition: "44.4097;-103.5091",
  geoPlacename: "Sturgis, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located approximately 360 miles south of Sturgis via I-25 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Sturgis", zips: "57785" },
    { name: "Fort Meade", zips: "57741" },
    { name: "Whitewood", zips: "57793" },
    { name: "Spearfish", zips: "57783" },
    { name: "Deadwood", zips: "57732" },
    { name: "Lead", zips: "57754" },
    { name: "Belle Fourche", zips: "57717" },
    { name: "Rapid City", zips: "57701" },
    { name: "Piedmont", zips: "57769" },
    { name: "Summerset", zips: "57718" },
    { name: "Nemo", zips: "57759" },
    { name: "Newell", zips: "57760" },
    { name: "Vale", zips: "57788" },
    { name: "Saint Onge", zips: "57779" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Denver Passport Agency — as fast as 24 hours for Sturgis-area travelers with immediate departures." },
    { icon: "ri-motorbike-line", title: "Motorcycle Industry International Travel", desc: "Sturgis is the global epicenter of motorcycle culture. We help rally vendors, custom bike builders, and industry professionals traveling to European and Asian motorcycle shows, races, and expos." },
    { icon: "ri-flight-takeoff-line", title: "Rapid City Regional Airport Access", desc: "RAP is just 35 miles away with daily connections to five major hubs — giving Sturgis travelers one-stop access to destinations worldwide." },
    { icon: "ri-shield-line", title: "Fort Meade Military Support", desc: "We serve Fort Meade personnel and families with deployment passport processing, PCS orders, and military international travel needs." },
  ],
  internalLinks: [
    { name: "Expedited passport in Rapid City, SD", route: "/rapid-city" },
    { name: "Quick passport services in Spearfish, SD", route: "/spearfish" },
    { name: "Fast passport services in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Urgent passport services in Deadwood, SD", route: "/spearfish" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Sturgis via secure registered courier with direct access to the Denver Passport Agency at 3151 S Vaughn Way, Suite 600, Aurora, CO 80014. Our registered couriers hand-deliver your documents — meaning you get faster results without the 360-mile drive. Sturgis residents can ship from any UPS Store, FedEx Office, or post office location across Meade County.",
  fpcOfficeDistance: "Serving Sturgis, Fort Meade, Whitewood, Piedmont, Summerset, and all Meade County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Sturgis and Meade County. From historic Main Street and the Sturgis Motorcycle Museum to Fort Meade, from the surrounding Black Hills communities to the agricultural areas of northern Meade County — we serve all of the Northern Black Hills region. Our courier service eliminates the need to drive six hours to the Denver Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Sturgis and surrounding communities including Fort Meade, Whitewood, Spearfish, Deadwood, and Belle Fourche. We also serve travelers departing from Rapid City Regional Airport (RAP) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Sturgis as simple as possible — with the efficiency and reliability motorcycle industry professionals, Fort Meade families, and Meade County residents need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Sturgis travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Sturgis travelers encounter unique passport issues — everything from last-minute international motorcycle show invitations to Fort Meade PCS orders to 6-month validity rules for European destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Sturgis travelers — from motorcycle industry professionals to Fort Meade families to Meade County residents — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Sturgis, SD? Here are the most common ones we hear from Meade County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a European motorcycle expo, an emergency passport for Fort Meade deployment, or a first-time passport for a Northern Hills family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "International motorcycle show in Germany this week? Fort Meade deployment orders with immediate departure? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Sturgis-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Sturgis residents renew fast — no agency visit required for most renewals. Perfect for motorcycle industry professionals, Fort Meade personnel, and Meade County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Sturgis residents through every step — from motorcycle industry employees to Fort Meade families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your motorcycle expo or military travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip to the European Alps or Canadian Rockies stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Sturgis residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Sturgis motorcycle industry professionals and Fort Meade personnel who travel abroad while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Sturgis-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Sturgis SD", description: "Urgent passport processing for Sturgis South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Sturgis SD", description: "Fast passport renewal for Sturgis South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Sturgis SD", description: "New passport application services for Sturgis South Dakota residents applying for their first passport." },
    { name: "Child Passport Sturgis SD", description: "Minor passport services for Sturgis South Dakota families with children under 16." },
    { name: "Name Change Passport Sturgis SD", description: "Passport name correction after marriage, divorce, or legal name changes for Sturgis residents." },
    { name: "Second Passport Sturgis SD", description: "Second passport services for Sturgis motorcycle industry professionals and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Mike D.",
      location: "Custom Bike Builder, Sturgis",
      rating: 5,
      text: "Got invited to display at a major European custom bike show with only 12 days notice. My passport was expired. Fast Passport Center got it renewed in 4 days. I was on a plane to Milan with my bike in the cargo hold.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sgt. Amanda K.",
      location: "Fort Meade, Sturgis",
      rating: 5,
      text: "Unexpected PCS orders with international component. Needed my family's passports renewed fast. They handled all four of us — every passport arrived before our report date.",
      service: "Military Family Passports",
    },
    {
      name: "The Hansen Family",
      location: "Meade County",
      rating: 5,
      text: "We booked an Alps motorcycle tour for our 25th anniversary. Both our passports were expired. They renewed both in under a week. Best anniversary trip ever.",
      service: "Passport Renewals",
    },
    {
      name: "Rally Vendor Tom S.",
      location: "Sturgis",
      rating: 5,
      text: "I vend at European motorcycle rallies in addition to Sturgis. My passport expired right before the season. They renewed it in 5 days. Did not miss a single rally.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "sturgis-1",
      name: "Sturgis Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1220 Main St",
      city: "Sturgis",
      state: "SD",
      zip: "57785",
      phone: "(605) 347-2960",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Sturgis",
      website: "https://tools.usps.com/find-location.htm?location=1368578",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Sturgis and Meade County. Passport photos available. Important note: accessibility and availability are severely limited during the annual Sturgis Motorcycle Rally (early August). Plan passport processing well outside Rally week.",
      icon: "ri-mail-line",
    },
    {
      id: "sturgis-2",
      name: "Meade County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "1425 Sherman St",
      city: "Sturgis",
      state: "SD",
      zip: "57785",
      phone: "(605) 347-4411",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Meade County Courthouse, Sturgis",
      website: "https://www.meadecounty.org/",
      websiteLabel: "Meade County",
      notes: "County clerk office offering passport acceptance services. Convenient for downtown Sturgis residents. Call ahead to confirm clerk availability — office may have limited passport services during Rally week.",
      icon: "ri-government-line",
    },
    {
      id: "sturgis-3",
      name: "Spearfish Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Yankee St",
      city: "Spearfish",
      state: "SD",
      zip: "57783",
      phone: "(605) 642-4187",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Spearfish — 20 miles northwest via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1368582",
      websiteLabel: "USPS Location",
      notes: "Excellent alternative acceptance facility during Rally week when Sturgis post office is overwhelmed. Passport photos available. About a 20-minute drive from Sturgis via I-90.",
      icon: "ri-mail-line",
    },
    {
      id: "sturgis-4",
      name: "Rapid City Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 East Blvd",
      city: "Rapid City",
      state: "SD",
      zip: "57701",
      phone: "(605) 348-2962",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Rapid City — 35 miles southeast via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1368577",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility with more appointment availability. Full photo services. Good option year-round — especially recommended during August when Sturgis facilities are at capacity.",
      icon: "ri-mail-line",
    },
    {
      id: "sturgis-5",
      name: "Belle Fourche Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "510 Grant St",
      city: "Belle Fourche",
      state: "SD",
      zip: "57717",
      phone: "(605) 892-2531",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Belle Fourche — 13 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1368575",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for northern Meade County and Butte County residents. Passport photos available. Quiet option away from Rally traffic.",
      icon: "ri-mail-line",
    },
    {
      id: "sturgis-6",
      name: "Fort Meade VA Passport Services",
      type: "Military/Veterans Passport Assistance",
      address: "113 Comanche Rd",
      city: "Fort Meade",
      state: "SD",
      zip: "57741",
      phone: "(605) 347-2511",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Fort Meade — 3 miles east of Sturgis",
      website: "https://www.va.gov/black-hills-health-care/",
      websiteLabel: "VA Black Hills",
      notes: "Passport assistance available for active duty military personnel stationed at Fort Meade. Contact the military personnel office for specific eligibility requirements and service availability.",
      icon: "ri-shield-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 360 miles to Denver Passport Agency", fpc: "Most Sturgis travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no motorcycle industry, Fort Meade, or Rally expertise", fpc: "Full motorcycle industry/Fort Meade/Meade County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Rally Season Passport Rush",
      description: "The Sturgis Motorcycle Rally (early August) brings 500,000+ visitors to the area, overwhelming local post offices and services. Passport processing during Rally week is extremely difficult — plan ahead or use Rapid City facilities instead.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Sturgis applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Sturgis pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Meade County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Fort Meade Deployment Timing",
      description: "Military families at Fort Meade occasionally receive deployment orders with international components on short notice. Passport processing under time pressure requires the expedition service — we understand military urgency and prioritize accordingly.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, shop, or Fort Meade quarters." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Sturgis clients ship from the UPS Store in Spearfish or FedEx in Rapid City — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 360 miles to Denver or wait at a crowded post office during Rally season." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Sturgis?", a: "We offer Sturgis-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Sturgis?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Sturgis post office or Meade County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Sturgis address." },
    { q: "Where can I get passport acceptance in Sturgis?", a: "Sturgis has passport acceptance at the Main Post Office (1220 Main St) and the Meade County Clerk of Courts (1425 Sherman St). Nearby options include post offices in Spearfish, Rapid City, and Belle Fourche. Fort Meade also offers military passport assistance for active duty personnel." },
    { q: "Does the Sturgis Motorcycle Rally affect passport services?", a: "Significantly. The Rally (first full week of August) brings over 500,000 visitors to Sturgis, overwhelming local post offices. We strongly recommend completing passport processing at least 3 weeks before or 2 weeks after Rally week. During Rally, use Rapid City or Spearfish facilities instead." },
    { q: "Can motorcycle industry professionals get expedited passports?", a: "Yes. Many Sturgis-based custom bike builders, rally vendors, and motorcycle industry professionals travel internationally to shows in Europe and Asia. Our expedited courier service accommodates the often-compressed timelines of international motorcycle events." },
    { q: "What documents do Sturgis applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Sturgis-specific checklist." },
    { q: "Can I get a passport photo in Sturgis?", a: "Yes — the Sturgis Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and Walgreens in Sturgis and Spearfish. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How far is the nearest passport agency from Sturgis?", a: "The Denver Passport Agency (1961 Stout St, Denver, CO) is approximately 360 miles south of Sturgis via I-25. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "How do I check my Sturgis passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Sturgis to final return shipping typically matches your chosen speed tier." },
    { q: "Does Fort Meade offer passport services for civilians?", a: "Fort Meade's passport assistance is generally limited to active duty military personnel and their families. Civilians should use the Sturgis Main Post Office, Meade County Clerk, or nearby facilities in Spearfish and Rapid City for passport acceptance services." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Sturgis Residents",
    intro: "Sturgis's global fame as the Motorcycle Rally city and its role as a Northern Black Hills community creates unique passport timing challenges. Here's what Sturgis travelers need to know.",
    cards: [
      {
        icon: "ri-motorbike-line",
        title: "Motorcycle Industry International Travel",
        subtitle: "European expos, Asian manufacturing visits, and global rally circuits",
        description: "Sturgis is the global brand name in motorcycling. Many local businesses — custom bike builders, parts manufacturers, apparel designers, and rally organizers — travel internationally for expos, factory visits, and motorcycle events in Germany, Italy, Japan, and Thailand. These trips often materialize with short notice when invited to display at prestigious shows.",
        tip: "Motorcycle industry professionals should maintain current passports year-round. International show invitations often come with 2–4 weeks notice, and expedited processing is frequently needed.",
      },
      {
        icon: "ri-shield-line",
        title: "Fort Meade Military Travel",
        subtitle: "Deployments, PCS orders, and military family international moves",
        description: "Fort Meade, adjacent to Sturgis, serves as a VA medical center and training facility. Military personnel and families face unique passport challenges: deployment orders can arrive with minimal notice, PCS moves may include international components, and military families often need synchronized passport renewals for multiple family members.",
        tip: "Fort Meade families should keep all family members' passports current. PCS orders do not wait for passport processing — having valid passports ready removes one critical variable from military moves.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Rapid City Regional Airport (RAP) Access",
        subtitle: "Five hub connections, one-stop worldwide access",
        description: "Rapid City Regional Airport is a 35-minute drive from Sturgis with daily connections to MSP, DEN, DFW, ORD, and SLC. Sturgis travelers have one-stop access to Europe, Asia, and Latin America. The short drive makes RAP the preferred departure point for international trips from the Northern Hills.",
        tip: "RAP is closest to Sturgis among all Northern Hills communities. Take advantage of morning flights to maximize connection options for international itineraries.",
      },
      {
        icon: "ri-calendar-event-line",
        title: "Planning Around the Sturgis Rally",
        subtitle: "August is a logistical blackout for passport processing in Sturgis",
        description: "The first full week of August transforms Sturgis from a town of 7,000 to a city of 500,000+. During Rally week and the surrounding two weeks, local infrastructure — post offices, shipping services, photo centers — is at or beyond capacity. Any passport processing attempted during this window faces severe delays. Smart planning means completing passport work well before Rally season.",
        tip: "Complete all passport processing by mid-July or wait until late August. Do not attempt passport applications, renewals, or acceptance facility visits during Rally week (first full week of August).",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Sturgis & the Global Motorcycle Economy",
      description: "Sturgis is more than a rally — it is a global brand. The motorcycle industry drives international travel from Sturgis year-round, not just in August. Custom builders, parts suppliers, and apparel companies travel to motorcycle shows in Germany, Italy, Japan, and beyond throughout the year.",
    },
  },
  destinations: {
    title: "Where Sturgis Travelers Go — And Why Passports Get Urgent",
    intro: "Sturgis's unique identity as the Motorcycle Rally capital creates diverse international travel patterns. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "35%", label: "of Sturgis expedited requests are motorcycle industry international travel" },
      { stat: "2–4 Weeks", label: "average lead time for custom builders receiving international show invitations" },
      { stat: "Aug", label: "avoid all passport processing during this month due to Rally disruption" },
      { stat: "360 Miles", label: "distance Sturgis residents avoid by using our courier instead of driving to the Denver agency" },
    ],
    destinations: [
      { name: "Germany", context: "Custom bike shows, Intermot and custom culture expos, BMW Motorrad partner visits", urgency: "Show dates fixed — 3–6 week notice for exhibitor invitations", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Milan motorcycle shows, EICMA international expo, custom builder showcases", urgency: "November show — apply by September for safe processing", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "Custom motorcycle culture, builder collaborations, parts manufacturing visits", urgency: "Long-lead planning but tight deadlines for collaboration opportunities", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Canadian motorcycle rallies, outdoor recreation shows, Rocky Mountain riding trips", urgency: "Summer rally season May–August, passport card popular for land crossings", icon: "ri-map-pin-2-line" },
      { name: "Thailand", context: "Motorcycle parts manufacturing, Southeast Asian custom bike scene, industry sourcing trips", urgency: "Business travel with 2–4 week lead time common", icon: "ri-map-pin-2-line" },
      { name: "Spain & Portugal", context: "European custom motorcycle events, riding tours, industry networking", urgency: "Spring and fall events booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Rapid City", route: "/rapid-city" },
      { name: "Spearfish", route: "/spearfish" },
      { name: "Sioux Falls", route: "/sioux-falls" },
    ],
  },
  photoLocations: [
    { name: "Sturgis Main Post Office", address: "1220 Main St, Sturgis, SD 57785", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Sturgis", address: "1240 Main St, Sturgis, SD 57785", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Sturgis", address: "2450 Lazelle St, Sturgis, SD 57785", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Sturgis", address: "2711 Lazelle St, Sturgis, SD 57785", hours: "Daily 8 AM – 10 PM" },
    { name: "UPS Store — Spearfish", address: "725 N Main St, Spearfish, SD 57783", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Spearfish Post Office", address: "120 Yankee St, Spearfish, SD 57783", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Rapid City Downtown Post Office", address: "500 East Blvd, Rapid City, SD 57701", hours: "Mon–Fri 9 AM – 4:30 PM" },
    { name: "FedEx Office — Rapid City", address: "2120 W Main St, Rapid City, SD 57702", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Rapid City DPS Driver License Exam Station",
      address: "1301 E Catron Blvd, Rapid City, SD 57701",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Nearest DPS exam station to Sturgis. Driver licenses, REAL ID, written and road tests. Appointment recommended. About a 30-minute drive from Sturgis via I-90.",
      featured: true,
    },
    {
      name: "Spearfish DPS Driver License Exam Station",
      address: "719 N Main St, Spearfish, SD 57783",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Alternative DPS exam station in Spearfish. REAL ID available. Convenient for northern Meade County residents. About a 15-minute drive from Sturgis via I-90.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RAP",
      name: "Rapid City Regional Airport",
      distance: "About 35 miles southeast of Sturgis via I-90",
      address: "4550 Terminal Rd, Rapid City, SD 57703",
      note: "Primary airport for the Black Hills region. Daily nonstop connections to MSP, DEN, DFW, ORD, and SLC — all major international gateways. About a 35-minute drive from Sturgis.",
      flightUrl: "https://www.rapairport.com/",
      flightLabel: "RAP Airport Website",
      featured: true,
    },
    {
      code: "GCC",
      name: "Gillette-Campbell County Airport",
      distance: "About 100 miles west of Sturgis via I-90",
      address: "2000 Airport Rd, Gillette, WY 82716",
      note: "Alternative regional airport in Wyoming with connections to DEN and SLC. About a 90-minute drive from Sturgis. Useful as a backup when RAP flights are limited.",
      flightUrl: "https://www.gillettewy.gov/city-government/departments/airport",
      flightLabel: "GCC Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Meade County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.meadecounty.org/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Meade County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.meadecounty.org/departments/clerk-of-courts",
    },
  ],
};